import {MenuOption} from '../../../menu-engine/MenuOption'
//import DynamicMenuOptionList from '../../../menu-engine/DynamicMenuOptionList'
import store from '../../../init/store.js'
import {setBattleValue} from '../../../redux-actions/battle-actions.js'
import {getCombatantIdFromSelectingString} from '../../get-combatant-id-from-selecting-string.js'
import {getSubmissionHomeMenuData, getSuperId} from './getSubmissionMenuDataHome'
import {getSubmissionActionOptionsData} from './getSubmissionMenuDataListView'
import {getTargets} from '../../get-targets.js'
import {arenaSubmitFinalAction} from '../ArenaSubmissionMenu.js'


export function getBattleArenaMenuData() {
  const rootOptions = {
    "firstOption": new MenuOption({
      label: "Ermm"
    }, "firstOption"),
  };

  //Get the current player
  //Assume this person is the player, right?
  // NOTE: cloudQueue actions will not make it through to here.
  //Only raw combatantIds and ::deadline ids

  const {combatantSelectingAction, combatants} = store.getState().battle;
  let playerModel = combatants[
    getCombatantIdFromSelectingString(combatantSelectingAction)
  ];

  if (!playerModel) {
    console.warn('no playerModel!!', combatantSelectingAction)
  }

  //Get home options
  const homeOptionModels = getSubmissionHomeMenuData(playerModel);
  const specialOptionModels = getSubmissionActionOptionsData(playerModel, "special");
  const itemsOptionModels = getSubmissionActionOptionsData(playerModel, "items");
  const superOptionModels = getSubmissionActionOptionsData(playerModel, "supers");


  return {
    disabledOptionClass: "is-disabled", //default "is-disabled"
    views: {
      "rootView": { //this is just for waiting. No options or UI
        viewBag: {
        },
        getMenuOptions() {
          return rootOptions
        },
        getMenuOptionsLayout() {
          return []
        },
        dontRememberOptionIds: []
      },

      "homeView": {
        viewBag: {
          title: "Select option",
        },
        getMenuOptions() {
          return homeOptionModels
        },
        getMenuOptionsLayout() {
          return Object.keys(homeOptionModels).map(key => [key]) //makes a vertical chain
        },
        dontRememberOptionIds: []
      },

      "specialsView": {
        viewBag: {
          title: "Select option",
        },
        getMenuOptions() {
          return specialOptionModels
        },
        getMenuOptionsLayout() {

          //Do not include BACK option in Layout (You can press ESC instead)
          const nonBackOptions = Object.keys(specialOptionModels).filter(key => {
            return key !== "listview-back"
          });

          return nonBackOptions.map(key => [key]) //makes a vertical chain
        },
        backOptionId: "listview-back", //ID of the "Back" option
        dontRememberOptionIds: ["listview-back"] //Don't allow this one to be autoselected if we come back
      },
      "itemsView": {
        viewBag: {
          title: "Select option",
        },
        getMenuOptions() {
          return itemsOptionModels
        },
        getMenuOptionsLayout() {

          //Do not include BACK option in Layout (You can press ESC instead)
          const nonBackOptions = Object.keys(itemsOptionModels).filter(key => {
            return key !== "listview-back"
          });

          return nonBackOptions.map(key => [key]) //makes a vertical chain
        },
        backOptionId: "listview-back", //ID of the "Back" option
        dontRememberOptionIds: ["listview-back"]
      },

      "supersView": {
        viewBag: {
          title: "Select option",
        },
        getMenuOptions() {
          return superOptionModels
        },
        getMenuOptionsLayout() {
          return Object.keys(superOptionModels).map(key => [key]) //makes a vertical chain
        },
        backOptionId: "listview-back",
        dontRememberOptionIds: ["listview-back"]
      },


      "targetsView" : {
        viewBag: {
          title: "Select target"
        },
        getMenuOptions() {
          return getTargetOptions();
        },
        getMenuOptionsLayout() {
          return getTargetOptionsLayout()
        },

        shouldRememberOptions: false, //Don't remember targeting

        //Which target should be selected first when the view lands?
        getFirstSelectedOptionOnActivation(availableOptionModels) {

          const selectedAction = store.getState().battle.arenaSubmissionMenuAction;
          // console.log('TARGET OPTIONS', availableOptionModels);

          //If we're using an item, default to the caster's targeting option id! (if it exists)
          if (selectedAction.isItem) {

            const selectingCombatantId = getCombatantIdFromSelectingString(
              store.getState().battle.combatantSelectingAction
            );

            //See if caster exists as a target option in availableOptionModels
            const casterTargetOption = availableOptionModels.find(optionModel => {
              return (
                optionModel.viewBag.targetIds && //We have targets
                optionModel.viewBag.targetIds.length === 1 && //Only 1 target (not a multi-person-targeting item)
                optionModel.viewBag.targetIds[0] === selectingCombatantId //and its the caster's ID
              )
            });

            //If so, return that.
            if (casterTargetOption) {
              //console.log('casterTargetOption', casterTargetOption)
              return casterTargetOption.id
            }
            //If not, just keep going. We'll default to the first option...
          }


          //TODO: If you wanted to add some "obvious targeting auto aim" kind of stuff, you should do it here!
          //Like, I select "SCOPE BOMB" so try to find an enemy that has "DEADLINE" first.


          //Default to first option
          return availableOptionModels[0].id; //Default to just use the first one!

        },

        backOptionId: "target-back",
        dontRememberOptionIds: ["target-back"]
      }
    }
  }
}



function getTargetOptions() {
  const {arenaSubmissionMenuAction, combatants, combatantSelectingAction} = store.getState().battle;

  //Bail here if we're not selecting a target right now
  if (!arenaSubmissionMenuAction) {
    return {}
  }

  //Get a Player Model
  const playerModel = combatants[
    getCombatantIdFromSelectingString(combatantSelectingAction)
  ];
  if (!playerModel) {
    console.warn('no playerModel in getTargetOptions', combatantSelectingAction)
  }


  let targetIds = getTargets(
    arenaSubmissionMenuAction.id,
    playerModel.belongsToTeam,
    playerModel.id
  );

  //If we have multiple targets, sort by arenaPosition (left to right)
  //This helps the keyboarding know the correct order of the layout.
  //Please note: We currently do not ever have cases where there are multiple targets AND single targets.
  //If it ever becomes ["one,two,three", "four"], then we'll need to rethink this.

  function convertArenaPositionForMain(number, targetsLength) {

    //This is a little silly, but "1" (on a team of 3) is actually in the middle. So we need to turn 1s into 2s and 2s into 1s
    if (targetsLength === 3 || targetsLength === 2) { //Only do this on 3 person teams. Positioning of 2 and 1 person teams are normal.
      if (number === 1) {
        return 2
      } //1 is actually in the middle position
      if (number === 2) {
        return 1
      } //2 is actually in the left position
    }

    return number;
  }



  if (targetIds.length > 1) {
    targetIds = targetIds.map(id => combatants[id]).sort((a,b) => {

      let aArenaPosition = convertArenaPositionForMain(a.arenaPosition, targetIds.length);
      let bArenaPosition = convertArenaPositionForMain(b.arenaPosition, targetIds.length);

      return aArenaPosition > bArenaPosition ? 1 : -1


    }).map(comb => comb.id)
  }


  let targetOptions = {};
  //Create Target options
  //(These are not actually displayed as a menuOptions loop or anything. ArenaCombatant components change appearance )
  targetIds.forEach((targetId, index) => {
    const key = `target-option-${index}`;
    targetOptions[key] = new MenuOption({
      label: "",
      viewBag: {
        //Keep a reference to combatant Ids so we can highlight them as target options in the View Layer (ArenaCombatant.js)
        targetIds: targetId.split(',') //["a"] for one, or ["a", "b"] for one option for multiple combatants
      },

      nextView: "rootView", //transition to a waiting state
      handleOptionEnter() {
        handleEnterOnTarget(targetId);
      }
    }, key); //use key as optionId too
  });



  //Add a back option

  //Determine the destination of the Back button
  //Assume we're targeting a special attack, so go back to the list view
  let backViewId = "specialsView";
  //Go back to Items view if cancelling from an Item
  if (arenaSubmissionMenuAction.isItem) {
    backViewId = "itemsView";
  }
  //Back to Supers if this is a super
  if (arenaSubmissionMenuAction.isSuper) {
    //If we have multiple supers showing, then go back to the list view.
    //Otherwise, jump back to homeView (because we only have 1 super)
    const playerSuperActionId = getSuperId(playerModel);
    backViewId = playerSuperActionId === "SHOW-ALL" ? "supersView" : "homeView";
  }
  //Go back to Home if cancelling out of regular Attack target
  if (arenaSubmissionMenuAction.id === "attack_generic-attack") {
    backViewId = "homeView";
  }

  targetOptions["target-back"] = new MenuOption({
    handleOptionEnter() {
      // console.log('HANDLE IT');
    },
    viewBag: {
      //This sort of ViewBag workaround (both for Targets and Back) is needed because we're not looping through options.
      isBackButton: true //Use this so the custom option UI knows to appear selected
    },
    nextView: backViewId
  }, "target-back");

  return targetOptions;
}

function handleEnterOnTarget(targetIds:string) {
  //Take IDs and make a targets array
  //const value = this.refs.select.value; //"oneA", or "oneB,oneC,oneD" string with commas
  const targetModels = targetIds.split(",").map(targetId => {
    return store.getState().battle.combatants[targetId]
  });

  //From here, either SUBMIT the action for real or wait for the extra timing bonus submission.
  //In either case, tell Redux about the targets
  // const actionModel = store.getState().battle.arenaSubmissionMenuAction;

  // if (false) { //TODO: Trying gameplay without this feature.
  //TODO: Leaving this here for a little bit for reference on how to add in that third step if we ever need it
  // //if (actionModel.hasTimedHitBonusAvailable) {
  //   setBattleValue({
  //     arenaSubmissionMenuTargets: targetModels
  //   });
  //
  // } else {
    //Submit the targets and completed flag

    setBattleValue({
      arenaSubmissionIsSubmitted: true,
      arenaSubmissionMenuTargets: targetModels
    });
    arenaSubmitFinalAction(); //submit for real!

  //}
}

function getTargetOptionsLayout() {
  //TODO: this will need to be a little more clever in possibly providing a multi-tream layout.

  //You might be able to get away with an "enemy row" then "friendly row" and only include the ones that have members.
  /*

  like, return [
    enemy list,
    friendly list,
  ]

  or just return [
    one of the lists
  ]

   */


  //TODO: for now, just provide everything as 1 horizontal row
  return [
    Object.keys( getTargetOptions() ).filter(key => key !== "target-back")
    //Removing the Back for now for playtesting
  ]; //Returns a horizontal list

}


// WEBPACK FOOTER //
// ./src/battle/ArenaView/SubmissionMenu/getSubmissionMenuData.js